import {RiskService} from "./service/RiskService";

import Dashboard from "./components";
import {routerConfig} from "./RouterConfig";
import {MarginLevelFilter, marginLevelFilter} from "./filters/MarginLevelFilter";

export default angular.module("tfApp.risk", [Dashboard])
                      .service(RiskService.id, RiskService)
                      .filter(MarginLevelFilter, marginLevelFilter)
                      .config(routerConfig)
                      .name;
